import initializeValues from './initializeValues';
import openModal from './openModal';
import setIsNewRecord from './setIsNewRecord';

export default (values) => (dispatch) => {
    dispatch(initializeValues(values));
    dispatch(setIsNewRecord(false));
    dispatch(openModal(true));
};
